import { render, staticRenderFns } from "./StaticInfos.vue?vue&type=template&id=7fc9bfb2&scoped=true"
import script from "./StaticInfos.vue?vue&type=script&lang=js"
export * from "./StaticInfos.vue?vue&type=script&lang=js"
import style0 from "./StaticInfos.vue?vue&type=style&index=0&id=7fc9bfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc9bfb2",
  null
  
)

export default component.exports